module.exports = __webpack_public_path__ + "img/ExlorerBrowser.6904c86e.svg";